export class B2BPackageManagementToken {
  static IB2BPackageManagementRepository = Symbol(
    "IB2BPackageManagementRepository",
  );
  static B2BPackageManagementUseCase = Symbol("B2BPackageManagementUseCase");
}
